/**
 * SocialMediaVideoService
 * Service for SocialMediaVideoAnalytics entity operations
 * Route: api/socialmedia/videos
 */
import { BaseService } from '../base/BaseService';
/**
 * SocialMediaVideoService
 * Handles social media video analytics queries
 */
export class SocialMediaVideoService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaVideoService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaVideoService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY ID ====================
    /**
     * Get video analytics by ID
     * GET api/socialmedia/videos/{id}
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Video ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get video analytics by ID with full response
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('get', id);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY ACCOUNT ====================
    /**
     * Get videos by account ID
     * GET api/socialmedia/videos/account/{accountId}
     */
    async getByAccount(accountId) {
        const response = await this.getByAccountRaw(accountId);
        return response.data ?? [];
    }
    /**
     * Get videos by account ID with full response
     */
    getByAccountRaw(accountId) {
        const endpoint = this.getEndpoint('by-account', `account/${accountId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET TOP PERFORMING ====================
    /**
     * Get top performing videos for an account
     * GET api/socialmedia/videos/account/{accountId}/top-performing?metricType={metricType}&limit={limit}
     */
    async getTopPerforming(accountId, metricType = 'Views', limit = 10) {
        const response = await this.getTopPerformingRaw(accountId, metricType, limit);
        return response.data ?? [];
    }
    /**
     * Get top performing videos with full response
     */
    getTopPerformingRaw(accountId, metricType = 'Views', limit = 10) {
        const endpoint = this.getEndpoint('top-performing', `account/${accountId}/top-performing`);
        const url = this.buildUrl(endpoint);
        const urlWithParams = `${url}?metricType=${encodeURIComponent(metricType)}&limit=${limit}`;
        return this.http.get(urlWithParams);
    }
}
SocialMediaVideoService.DEFAULT_SERVICE_PATH = 'social-media';
SocialMediaVideoService.BASE_PATH = 'api/socialmedia/videos';
//# sourceMappingURL=SocialMediaVideoService.js.map